// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__304Ex","empty":"ModalGraph_empty__3i9Ox"};